import { Button } from "@/components/ui/button";
import { Heart, Phone, Mail, MapPin, Instagram, MessageCircle } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img 
              src="/images/latest-logo.png" 
              alt="Sweets by Gem - Cake Designer" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 leading-relaxed mb-6 max-w-md">
              Cake design à Villeurbanne. Chaque gâteau est une création unique, 
              faite avec passion et des ingrédients de qualité pour sublimer vos moments précieux.
            </p>
            <div className="flex space-x-4">
              <Button
                variant="outline"
                size="sm"
                onClick={() => window.open("https://wa.me/33753797698", "_blank")}
                className="border-primary text-primary hover:bg-primary hover:text-white"
              >
                <MessageCircle className="w-4 h-4 mr-2" />
                WhatsApp
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={() => window.open("https://www.instagram.com/sweetsby_gem", "_blank")}
                className="border-accent text-accent hover:bg-accent hover:text-white"
              >
                <Instagram className="w-4 h-4 mr-2" />
                Instagram
              </Button>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              {[
                { name: "Accueil", href: "#accueil" },
                { name: "Nos Créations", href: "#creations" },
                { name: "Tarifs", href: "#tarifs" },
                { name: "À Propos", href: "#apropos" },
                { name: "Contact", href: "#contact" }
              ].map((item) => (
                <li key={item.name}>
                  <button
                    onClick={() => scrollToSection(item.href)}
                    className="text-gray-300 hover:text-primary transition-smooth text-sm"
                  >
                    {item.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-3 text-sm text-gray-300">
              <div className="flex items-start">
                <MapPin className="w-4 h-4 mr-2 text-primary mt-0.5 flex-shrink-0" />
                <div>
                  <div>3 rue Magenta</div>
                  <div>69100 Villeurbanne</div>
                </div>
              </div>
              
              <div className="flex items-center">
                <Phone className="w-4 h-4 mr-2 text-primary flex-shrink-0" />
                <a 
                  href="tel:+33753797698"
                  className="hover:text-primary transition-smooth"
                >
                  +33 7 53 79 76 98
                </a>
              </div>
              
              <div className="flex items-center">
                <Mail className="w-4 h-4 mr-2 text-primary flex-shrink-0" />
                <a 
                  href="mailto:gemimankdu9@icloud.com"
                  className="hover:text-primary transition-smooth"
                >
                  gemimankdu9@icloud.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-sm text-gray-400 mb-4 md:mb-0">
              © {currentYear} Sweets by Gem. Tous droits réservés.
            </div>
            <div className="flex items-center text-sm text-gray-400">
              <span>Fait avec</span>
              <Heart className="w-4 h-4 mx-1 text-primary" />
              <span>à Villeurbanne</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;